import { useSelector } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

import Points from './Points';

const ItemPrice = (props) => {
  const { item } = props;
  const { modifiers } = item;

  const { t } = useLocalization();
  const settings = useSelector((state) => state.setting.data);
  const { currency } = settings;

  //   TODO Handle Pickup to Ship
  //   if (item.purchaseType === 'Pickup To Ship') {
  //     return (
  //       <div className="c7-order-item__price">
  //         -
  //       </div>
  //     );
  //   }

  if (
    modifiers &&
    modifiers.priceBeforeModifiers !== modifiers.comparePriceBeforeModifiers
  ) {
    return (
      <div className="c7-order-item__price">
        <span className="c7-sr-only">
          {t('general.accessibility.itemPrice')}
        </span>
        <span className="c7-price--original">
          <span className="c7-sr-only">{t('general.accessibility.was')} </span>
          {currencyFormat(modifiers.comparePriceBeforeModifiers, currency)}
        </span>
        <span className="c7-price--discounted">
          <span className="c7-sr-only">{t('general.accessibility.now')} </span>
          {currencyFormat(modifiers.priceBeforeModifiers, currency)}
        </span>
        <Points item={item} />
      </div>
    );
  }

  if (modifiers) {
    return (
      <div className="c7-order-item__price">
        <span className="c7-sr-only">
          {t('general.accessibility.itemPrice')}
        </span>
        <span className="c7-sr-only">{t('general.accessibility.now')} </span>
        {currencyFormat(modifiers.comparePriceBeforeModifiers, currency)}
        <Points item={item} />
      </div>
    );
  }

  if (item.comparePrice > item.price) {
    return (
      <div className="c7-order-item__price">
        <span className="c7-sr-only">
          {t('general.accessibility.itemPrice')}
        </span>
        <span className="c7-price--original">
          <span className="c7-sr-only">{t('general.accessibility.was')} </span>
          {currencyFormat(item.comparePrice, currency)}
        </span>
        <span className="c7-price--discounted">
          <span className="c7-sr-only">{t('general.accessibility.now')} </span>
          {currencyFormat(item.price, currency)}
        </span>
        <Points item={item} />
      </div>
    );
  }

  return (
    <div className="c7-order-item__price">
      <span className="c7-sr-only">{t('general.accessibility.itemPrice')}</span>
      <span>{currencyFormat(item.price, currency)}</span>
      <Points item={item} />
    </div>
  );
};

export default ItemPrice;
